import { StarIcon } from "@heroicons/react/24/solid";
import { Home, Users } from "lucide-react";
import StayCard from "components/StayCard/StayCard";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "redux/store";
import { getExclusiveProperty } from "redux/reducers/Properties/PropertiesSlice";
import { resetSearch } from "redux/reducers/Search/SearchSlice";

export default function HotelBooking() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { exclusiveProperty, loading } = useSelector(
    (state: RootState) => state.property
  );

  useEffect(() => {
    dispatch(getExclusiveProperty());
  }, [dispatch]);

const handleBrowse = () => {
  dispatch(resetSearch());
  navigate("/properties"); // ← change from "/listing-stay-map"
};

  return (
    <div className="min-h-screen bg-white dark:bg-neutral-900">

      {/* Compact Page Title */}
      <header className="container mx-auto px-4 pt-10 pb-0 lg:pt-16">
        <div className="max-w-2xl">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-[#f5694b] mb-3">
            Lima, Peru · Student Housing
          </span>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white leading-snug">
            Exclusive Properties
          </h1>
          <p className="text-sm text-gray-400 dark:text-gray-500 mt-1">
            Handpicked rooms and apartments in Lima's most vibrant neighborhoods.
          </p>
        </div>
      </header>

      {/* Properties */}
      <section className="py-10 lg:py-16">
        <div className="container mx-auto px-4">

          {loading ? (
            <div className="flex justify-center items-center py-20">
              <div className="animate-spin rounded-full h-10 w-10 border-4 border-[#f5694b] border-t-transparent" />
            </div>
          ) : Array.isArray(exclusiveProperty) && exclusiveProperty.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {exclusiveProperty.map((item) => (
                <div key={item.id} className="transform transition-all duration-300 hover:-translate-y-1">
                  <StayCard data={item} />
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-20 bg-gray-50 dark:bg-neutral-800 rounded-2xl">
              <Home className="w-12 h-12 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-400">No properties available at the moment.</p>
            </div>
          )}
        </div>
      </section>

      {/* Bottom CTA Banner */}
      <section className="bg-gradient-to-br from-[#f5694b] to-[#e2583d] dark:from-[#c94a30] dark:to-[#b83d25]">
        <div className="container mx-auto px-4 py-16 lg:py-20 flex flex-col items-center text-center">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-white/70 mb-4">
            Lima, Peru · Student Housing
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-[1.15] mb-4 max-w-2xl">
            Your home<br />away from home
          </h2>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
            Premium rooms in Lima's most vibrant neighborhoods — handpicked for students and young professionals.
          </p>
          <button
            onClick={handleBrowse}
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-[#f5694b] font-bold rounded-full shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 text-sm"
          >
            Browse All Properties
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </button>
        </div>
      </section>

    </div>
  );
}